/**
 * Возможность браузера в асинхронный режим работы
 */
export const isAsync = (function () {
  let _isAsync = false;
  try {
    // tslint:disable-next-line:no-eval
    eval('async () => {}');
    _isAsync = true;
  } catch (e) {
    if (e instanceof SyntaxError) {
      _isAsync = false;
    } else {
      throw e;
    }
  }

  return (): boolean => _isAsync;
})();



// WEBPACK FOOTER //
// ./src/app/utils/isAsync.ts